import {
    EMAIL_FETCHING,
    EMAIL_FAILED,
    EMAIL_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMAIL_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EMAIL_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EMAIL_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
};
